<!-- CREATE -->
<mat-card *ngIf="(isCurrentStatus('create') || isCurrentStatus('update')) && !isLoading()">
    <div class="dynamic-content-container">
        <div *ngFor="let field of config.props" class="dynamic-crud-field">
            <!-- INTEGER OR VARCHAR -->
            <app-dynamic-input *ngIf="getFieldType(field) === 'varchar' || getFieldType(field) === 'number'" [data]="field" (dataOut)="updateFormField($event)"></app-dynamic-input>
            <!-- DATE -->
            <app-dynamic-date-picker *ngIf="getFieldType(field) === 'date'" [data]="field" (dataOut)="updateFormField($event)"></app-dynamic-date-picker>
            <!-- BOOLEAN -->
            <mat-slide-toggle *ngIf="getFieldType(field) === 'boolean'" [(ngModel)]="field.value">{{ field.columnName }}</mat-slide-toggle>
            <!-- TEXTAREA -->
            <app-dynamic-textarea *ngIf="getFieldType(field) === 'text'" [data]="field" (dataOut)="updateFormField($event)"></app-dynamic-textarea>
            <!-- TIMESTAMP -->
            <app-dynamic-timestamp-picker *ngIf="getFieldType(field) === 'timestamp'" [data]="field" (dataOut)="updateFormField($event)"></app-dynamic-timestamp-picker>
            <!-- FK SELECT -->
             <app-dynamic-crud-select *ngIf="getFieldType(field) === 'select'" [data]="field" [status]="getCurrentStatus()"  (dataOut)="updateFormField($event)"></app-dynamic-crud-select>
        </div>
    </div>

      <div class="flex space-between topmargin-sm bottommargin-sm">
          
        <button mat-icon-button color="primary" *ngIf="isCurrentStatus('create') || isCurrentStatus('update')" (click)="setCurrentStatus('read')" aria-label="">
            <mat-icon><i class="fas fa-arrow-circle-left"></i></mat-icon>
        </button>
        <button mat-icon-button color="primary" (click)="showDebugCard = !showDebugCard" aria-label="">
            <mat-icon>developer_mode</mat-icon>
        </button>
        <button *ngIf="isCurrentStatus('create')" mat-icon-button color="primary" [disabled]="!isFormValid()" (click)="create()" aria-label="">
            <mat-icon><i class="fas fa-plus-circle"></i></mat-icon>
        </button>
        <button mat-icon-button  *ngIf="isCurrentStatus('update')" [disabled]="!isFormValid()" (click)="saveChanges()" color="primary" aria-label="">
            <mat-icon>save</mat-icon>
        </button>
    </div>
      
</mat-card>

<!-- DEBUG -->
<mat-accordion class="debug-card"  *ngIf="showDebugCard">
    <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
           Debug info:
          </mat-panel-title>
          <mat-panel-description>
            
          </mat-panel-description>
        </mat-expansion-panel-header>
        <div class="flex-column">
            <!-- <span>Table: {{ crudConfig.tableName }}</span>
            <span>Crud id: {{ crudConfig.id }}</span> -->
            <span>Status: {{getCurrentStatusAsString()}}</span>
            <span style="word-wrap: break-word;font-family: monospace;">{{getCurrentObjectAsString()}}</span>
        </div>
        
      </mat-expansion-panel>

    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          Current Object
        </mat-panel-title>
        <mat-panel-description>
        </mat-panel-description>
      </mat-expansion-panel-header>
      <span style="word-wrap: break-word;font-family: monospace;">Current Object: {{getCurrentObjectAsString()}}</span>
    </mat-expansion-panel>

    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          Last inserted
        </mat-panel-title>
        <mat-panel-description>
          
        </mat-panel-description>
      </mat-expansion-panel-header>
      <span style="word-wrap: break-word;font-family: monospace;">Last Inserted: {{getLastInsertedObjectAsString()}}</span>
    </mat-expansion-panel>
</mat-accordion>